export enum FeatureFlag {
  TestError = 'test_error', // open for my account, for testing sentry integration
  Imports = 'imports', // open for impersonate mode
  GglDomainInstallEmail = 'ggl_domain_install_email', // open for impersonate mode
  DashboardAccountsTable = 'dashboard_accounts_table', // Open for specific customers who requested this
  AcknowledgeDashboardInsight = 'Acknowledge dashboard insight', // Open for specific customers who requested this
  ExtendedDashboardSummaryItems = 'extended dashboard summary items', // Open for specific customers who requested this
  ProductSwitcher = 'product switcher',
  ServicenowIntegration = 'servicenow integration',
  EnableCRMIntegrationsForTrialOrgs = 'enable CRM integrations for trial orgs',
  LoginAsPermission = 'login as permission',
  VideoCallTroubleshoot = 'video call troubleshoot',
  PartialUserRefLists = 'partial user ref lists'
}
